import { CanvasDrawer } from "./CanvasDrawer";
import { CanvasImage } from "./CanvasImage";

interface SerializedCanvasImage {
    imageID: string;
    itemIndex: number;
    itemID: string;
    TL_imageBounds: { x: number; y: number };
    BR_imageBounds: { x: number; y: number };
    rotation: number;
    flipped: boolean;
    selected: boolean;
}

export const UndoRedoHelper = {
    undoStack: [] as SerializedCanvasImage[][],
    isInitialized: false,

    createSnapShot: function () {
        const snapshot = JSON.parse(JSON.stringify(CanvasDrawer.canvasImages));
        this.undoStack.push(snapshot);
    },

    undo: function () {

        if (this.undoStack.length <= 1) {
            console.log("Undo stack too short to undo");
            return;
        }

        const currentUndoStack = this.undoStack.pop();
        if (!currentUndoStack) return;

        const previous = this.undoStack[this.undoStack.length - 1];
        CanvasDrawer.canvasImages = this.rehydrateSnapshot(previous);

        const lastSelectedImageItemID = currentUndoStack.find((img: SerializedCanvasImage) => img.selected)?.itemID;
        const target = CanvasDrawer.canvasImages.find((img: CanvasImage) => img.itemID === lastSelectedImageItemID);
        if (target) target.selected = true;

        if (currentUndoStack.length < previous.length) {
            for (const item of previous) {
                let found = false
                for (const item2 of currentUndoStack) {
                    if (item.itemID === item2.itemID) {
                        found = true
                    }
                }
                if (!found) {
                    const target = CanvasDrawer.canvasImages.find((img: CanvasImage) => img.itemID === item.itemID);
                    if (target) target.selected = true;
                }
            }
        }
    },

    rehydrateSnapshot: function (snapshot: SerializedCanvasImage[]): CanvasImage[] {
        return snapshot.map(data => {
            const image = new CanvasImage(
                data.imageID,
                data.itemIndex,
                data.TL_imageBounds,
                data.BR_imageBounds
            );
            image.itemID = data.itemID
            image.selected = false;
            image.rotation = data.rotation;
            image.flipped = data.flipped;
            return image;
        });
    }
}
